// function coSetResponsiveFontSize() {
//     const root = document.documentElement;
//     const vw = window.innerWidth / 10;
//     root.style.setProperty('--co-vw-font-size', `${vw}px`);
// }
// coSetResponsiveFontSize();
// window.addEventListener('resize', coSetResponsiveFontSize);
// const coImagesGlobalLoader = document.querySelectorAll('img.co-img-loader');
// coImagesGlobalLoader.forEach((img) => {
//     const coHandleImageLoad = () => {
//         img.classList.add("co-img-loaded");
//     };
//     if (img.complete) {
//         img.classList.add("co-img-completed");
//     } else {
//         img.addEventListener('load', coHandleImageLoad);
//     }
// });
function coSetResponsiveFontSize() {
    const root = document.documentElement;
    const vw = window.innerWidth / 10;
    root.style.setProperty('--co-vw-font-size', `${vw}px`);
}
coSetResponsiveFontSize();
window.addEventListener('resize', coSetResponsiveFontSize);
document.querySelectorAll('img.co-img-loader').forEach((img) => {
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', () => { img.classList.add("co-img-loaded"); }, { once: true });
    }
});

new MutationObserver(() => {
    document.querySelectorAll('img.co-img-loader:not(.co-img-loaded):not(.co-img-completed)').forEach((img) => {
        if (img.complete) img.classList.add("co-img-completed");
    });
}).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });